import { StatusType, CountryCompliance } from '../../../types'

export const mapCountryComplianceStatus = (
  countryCompliance: CountryCompliance
): StatusType.Approved | StatusType.Rejected | StatusType.Pending => {
  if (countryCompliance.status === 'pass') {
    return StatusType.Approved
  }

  // pbp-api treats an unknown result as a failed check
  if (countryCompliance.status === 'fail' || countryCompliance.status === 'unknown') {
    return StatusType.Rejected
  }

  return StatusType.Pending
}
